import { createBrowserHistory } from 'history';
export default createBrowserHistory();

/**
 * This is implemented as suggested via the React Router docs
 *
 */
/* tslint:disable-next-line max-line-length */
// https://github.com/ReactTraining/react-router/blob/master/FAQ.md#how-do-i-access-the-history-object-outside-of-components
